class BxfTooltipConstants {
    static STRING = {
        TARGET: 'target',
        CONTENT: 'content',
        MOUSEOVER: 'mouseover',
        MOUSEOUT: 'mouseout',
        SCROLL: 'scroll',
        RESIZE: 'resize',
        MOUSEMOVE: 'mousemove',
        HOVER_TIMEOUT: 100,
        CONTAINER: 'bxf-tooltip__container',
    };
}

export { BxfTooltipConstants as B };
